import React, { FunctionComponent } from 'react';
import ProductComponent, {
  TParentComponentProps,
} from '@views/components/common/ParentComponent';

export const WidgetGroup: FunctionComponent<TParentComponentProps> = (
  props
) => <ProductComponent {...props} />;
WidgetGroup.defaultProps = {
  defaultClassName: 'widget__group',
};

export default WidgetGroup;
